
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest, apiRequest2 } from '../_helpers/apiConfig';



export const getAllSubscriptionList = createAsyncThunk("subscription/listForAdmin", async (filters) => {
    const response = await apiRequest('POST', '/v1/subscription/listForAdmin', filters);
    return response;
});


export const updateSubscriptionStatus = createAsyncThunk("/subscription/disablePlan",
    async (arg, thunkAPI) => {
        const { Payload, forReferesh } = arg;
        const response = await apiRequest("POST", "/v1/subscription/disablePlan", Payload);
        if (response.message) {
            thunkAPI.dispatch(getAllSubscriptionList(forReferesh));

        }
        return response;
    }
);
export const deletePlan = createAsyncThunk("/subscription/deletePlan",
    async (arg, thunkAPI) => {
        const { Payload, forReferesh } = arg;
        const response = await apiRequest("POST", "/v1/subscription/deletePlan", Payload);
        if (response.message) {
            thunkAPI.dispatch(getAllSubscriptionList(forReferesh));

        }
        return response;
    }
);

export const getPlanDataForAdmin = createAsyncThunk("/subscription/getPlanDataForAdmin",
    async (arg) => {
        const response = await apiRequest("POST", "/v1/subscription/getPlanDataForAdmin", arg);
        return response;
    }
);

export const subscribedUserList = createAsyncThunk("/subscription/subscribedUserList",
    async (arg) => {
        const response = await apiRequest("POST", "/v1/subscription/subscribedUserList", arg);
        return response;
    }
);

export const disableSubscriptionUser = createAsyncThunk("/subscription/disableSubscriptionUser",
    async (arg) => {
        const response = await apiRequest("POST", "/v1/subscription/disableSubscriptionUser", arg);
        return response;
    }
);  

export const getTotalSubscriptionData = createAsyncThunk("/subscription/getTotalSubscriptionData",
    async () => {
        const response = await apiRequest("POST", "/v1/subscription/getTotalSubscriptionData");
        return response;
    }
);  


const teachersSubscription = createSlice({
    name: 'teachersSubscription',
    initialState: {
        subscriptionListData: [],
        subscriptionListTotal: [],
        updateSubscriptionStatus: [],
        getPlanDataForAdminData: [],
        subscribedUserListData: [],
        deletePlan: [],
        disableSubscriptionUserData: [],
        getTotalSubscriptionDataData: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllSubscriptionList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllSubscriptionList.fulfilled, (state, action) => {
                state.loading = false;
                state.subscriptionListData = action?.payload?.data?.list;
                state.subscriptionListTotal = action?.payload?.data?.total;

            })
            .addCase(getAllSubscriptionList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(updateSubscriptionStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateSubscriptionStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.updateSubscriptionStatus = action?.payload;

            })
            .addCase(updateSubscriptionStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(deletePlan.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deletePlan.fulfilled, (state, action) => {
                state.loading = false;
                state.deletePlan = action?.payload;

            })
            .addCase(deletePlan.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(getPlanDataForAdmin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getPlanDataForAdmin.fulfilled, (state, action) => {
                state.loading = false;
                state.getPlanDataForAdminData = action?.payload?.data;

            })
            .addCase(getPlanDataForAdmin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(subscribedUserList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(subscribedUserList.fulfilled, (state, action) => {
                state.loading = false;
                state.subscribedUserListData = action?.payload?.data?.list;

            })
            .addCase(subscribedUserList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(disableSubscriptionUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(disableSubscriptionUser.fulfilled, (state, action) => {
                state.loading = false;
                state.disableSubscriptionUserData = action?.payload;

            })
            .addCase(disableSubscriptionUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(getTotalSubscriptionData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getTotalSubscriptionData.fulfilled, (state, action) => {
                state.loading = false;
                state.getTotalSubscriptionDataData = action?.payload?.data;

            })
            .addCase(getTotalSubscriptionData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })






    },
});

export default teachersSubscription.reducer;